import type { NavLink, SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'
import { media } from '@/constants/media'

export const siteConfig: SiteConfig = {
    name: "Atrium",
    description: "Atrium is an independent creative studio in Cannes making brand identities, films and editorial work for companies with something real to say.",
    url: getOrigin(),
    ogImage: media.ogImage
}

export const primaryLinks: NavLink[] = [
    { label: "Work", href: '/work' },
    { label: "About", href: '/about' },
    { label: "Journal", href: '/journal' },
    { label: "Contact", href: '/contact' }
]

export const footerLinks: NavLink[] = [
    { label: "Work", href: '/work' },
    { label: "About", href: '/about' },
    { label: "Journal", href: '/journal' }
]

export const legalLinks: NavLink[] = [
    { label: "Terms of use", href: '/legal/terms-of-use' },
    { label: "Privacy policy", href: '/legal/privacy-policy' },
    { label: "Cookies", href: '/legal/cookies' }
]
